// extracted by mini-css-extract-plugin
export default {"tagsContainer":"Tags_tagsContainer__S5Rb5","tag":"Tags_tag__XHeSF","selected":"Tags_selected__7q-KX"};